<template>
     <hr class="my-5 border-b-4 border-gray-100 dark:border-gray-800 rounded">
</template>